// extracted by mini-css-extract-plugin
module.exports = {"AdStatusContainer":"AdStatus_AdStatusContainer__R2A29","TimeLeft":"AdStatus_TimeLeft__31vW7","status":"AdStatus_status__3LVlM"};